// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__2GsvX","item":"Menu_item__3jsNX","divider":"Menu_divider__2ZtZ8"};